import { useState } from 'react';
import { useDispatch } from 'react-redux';

// ANTD
import { Pagination } from 'antd';
import { push } from 'connected-react-router';

import useParseQueryParams from 'hook/useParseQueryParams';

const DecoupledPagination = ({ pagination }) => {
  const dispatch = useDispatch();
  const { usp, pathname } = useParseQueryParams();
  const [, setSelectedRowKeys] = useState([]);

  function onPageChange(page) {
    setSelectedRowKeys([]);
    if (page) {
      usp.set('page', page);
    } else {
      usp.delete('page');
    }

    dispatch(push(`${pathname}?${usp}`));
  }

  function onShowSizeChange(_, size) {
    if (size) {
      usp.set('limit', size);
    } else {
      usp.delete('limit');
    }

    dispatch(push(`${pathname}?${usp}`));
  }

  return (
    <Pagination
      className="decoupled-pagination"
      key={Math.random()}
      {...{
        defaultPageSize: pagination?.limit || pagination?.per_page,
        current: parseInt(pagination.current_page),
        total: parseInt(pagination?.total_items || pagination?.total),
        onChange: onPageChange,
        pageSizeOptions: [10, 20, 50, 100],
        onShowSizeChange,
        showSizeChanger: false,
        showTotal: (total, range) => `${range[0]}〜${range[1]}件/${total}件`,
      }}
    />
  );
};

export default DecoupledPagination;
